// prettier-ignore
export const CAPABILITY_VIEW_MOODLE_LINK = 'local/extlms:eshop_view_moodle_link'
